(function () {

  const DONATION_VARIANTS = {
    5:  '51450343063847',
    10: '51450343096615',
    25: '51450343129383'
  };

  const DEFAULT_AMOUNT = 10;
  let selectedAmount = DEFAULT_AMOUNT;
  let isPopupOpen = false;

  const style = document.createElement('style');
  style.innerHTML = `
    #don-overlay {
      position: fixed; inset: 0;
      background: rgba(0,0,0,0.5);
      z-index: 9998;
      animation: donFadeIn 0.2s ease;
    }
    #don-box {
      position: fixed;
      top: 50%; left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      padding: 2rem 1.75rem;
      border-radius: 20px;
      z-index: 9999;
      text-align: center;
      max-width: 380px;
      width: 90%;
      animation: donSlideUp 0.25s ease;
    }
    @keyframes donFadeIn { from { opacity: 0 } to { opacity: 1 } }
    @keyframes donSlideUp { from { transform: translate(-50%, -44%); opacity: 0 } to { transform: translate(-50%, -50%); opacity: 1 } }
    #don-icon {
      width: 52px; height: 52px;
      border-radius: 50%;
      background: #FAECE7;
      display: flex; align-items: center; justify-content: center;
      margin: 0 auto 1rem;
      font-size: 24px;
    }
    #don-box .don-tag {
      font-size: 11px;
      font-weight: 500;
      letter-spacing: 0.08em;
      color: #888;
      text-transform: uppercase;
      margin: 0 0 6px;
    }
    #don-box h3 {
      font-size: 18px;
      font-weight: 600;
      color: #111;
      margin: 0 0 8px;
    }
    #don-box p {
      font-size: 14px;
      color: #666;
      margin: 0 0 1.5rem;
      line-height: 1.6;
    }
    #don-amts {
      display: flex;
      gap: 10px;
      justify-content: center;
      margin-bottom: 1.25rem;
    }
    .don-amt {
      flex: 1;
      padding: 10px 0;
      border-radius: 10px;
      border: 1px solid #ddd;
      background: #f5f5f5;
      font-size: 15px;
      font-weight: 500;
      cursor: pointer;
      color: #333;
      transition: all 0.15s ease;
    }
    .don-amt.active {
      border: 2px solid #D85A30;
      background: #FAECE7;
      color: #993C1D;
    }
    #don-yes {
      width: 100%;
      padding: 13px;
      border-radius: 10px;
      border: none;
      background: #D85A30;
      color: #fff;
      font-size: 15px;
      font-weight: 600;
      cursor: pointer;
      margin-bottom: 10px;
      transition: background 0.2s ease, transform 0.1s ease;
    }
    #don-yes:hover { background: #c24f28; }
    #don-yes:active { transform: scale(0.98); }
    #don-yes.success { background: #0F6E56; }
    #don-no {
      background: none;
      border: none;
      color: #aaa;
      font-size: 13px;
      cursor: pointer;
      text-decoration: underline;
      padding: 4px;
      display: block;
      margin: 0 auto;
    }
    #don-no:hover { color: #888; }
    #don-footer {
      font-size: 11px;
      color: #aaa;
      margin: 1rem 0 0;
      line-height: 1.5;
    }
  `;
  document.head.appendChild(style);

  function updateYesBtn() {
    const btn = document.getElementById('don-yes');
    if (btn) btn.textContent = 'Yes, add $' + selectedAmount + ' to my order';
  }

  function createPopup() {
    const wrap = document.createElement('div');
    wrap.id = 'don-wrap';
    wrap.innerHTML = `
      <div id="don-overlay"></div>
      <div id="don-box">
        <div id="don-icon">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
            <path d="M12 21C12 21 3 13.5 3 8a5 5 0 0 1 9-3 5 5 0 0 1 9 3c0 5.5-9 13-9 13z" fill="#D85A30" opacity="0.2"/>
            <path d="M12 21C12 21 3 13.5 3 8a5 5 0 0 1 9-3 5 5 0 0 1 9 3c0 5.5-9 13-9 13z" stroke="#D85A30" stroke-width="1.8" stroke-linejoin="round"/>
          </svg>
        </div>
        <p class="don-tag">One small step</p>
        <h3>Support the American Breast Cancer Foundation</h3>
        <p>Your order is ready! Would you like to add a donation alongside your purchase?</p>
        <div id="don-amts">
          <button class="don-amt" data-amount="5">$5</button>
          <button class="don-amt active" data-amount="10">$10</button>
          <button class="don-amt" data-amount="25">$25</button>
        </div>
        <button id="don-yes">Yes, add $10 to my order</button>
        <button id="don-no">No thanks, skip donation</button>
        <p id="don-footer">100% of your donation goes directly to the American Breast Cancer Foundation</p>
      </div>
    `;
    document.body.appendChild(wrap);
    return wrap;
  }

  function closePopup() {
    const wrap = document.getElementById('don-wrap');
    if (wrap) { document.body.removeChild(wrap); isPopupOpen = false; }
  }

  async function addDonationToCart(variantId) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
    });
  }

  function showPopup() {
    if (isPopupOpen) return;
    isPopupOpen = true;
    selectedAmount = DEFAULT_AMOUNT;

    const wrap = createPopup();

    wrap.querySelectorAll('.don-amt').forEach(btn => {
      btn.addEventListener('click', function () {
        wrap.querySelectorAll('.don-amt').forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        selectedAmount = parseInt(this.dataset.amount);
        updateYesBtn();
      });
    });

    document.getElementById('don-yes').addEventListener('click', async function () {
      this.textContent = 'Adding...';
      this.disabled = true;
      await addDonationToCart(DONATION_VARIANTS[selectedAmount]);
      this.classList.add('success');
      this.textContent = 'Donation added!';
      setTimeout(() => { closePopup(); window.location.href = '/cart'; }, 800);
    });

    document.getElementById('don-no').addEventListener('click', function () {
      closePopup();
      window.location.reload();
    });
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('button[name="add"], button[type="submit"]');
    if (!btn) return;
    const form = btn.closest('form[action="/cart/add"]');
    if (!form) return;

    e.preventDefault();
    e.stopPropagation();

    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(() => showPopup())
      .catch(() => showPopup());

  }, true);

})();